import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Rating } from 'semantic-ui-react';
import { useAuth } from '../../hooks/auth';
import { useSkills } from '../../hooks/skills';
import { SkillsService } from '../../services/skills';

import { getGradient } from '../../utils/getGradient'

import {
  SkillNiveisContainer,
  SkillNivelCircle
} from './styles';

interface Props {
  color: string;
  nvl: number;
  code: string;
}

const SkillNiveis: React.FC<Props> = ({ color, nvl, code }) => {
  const [nivel, setNivel] = useState(nvl)
  const [colors, setColors] = useState<string[]>([])

  const { updateSkillLevel } = useSkills()


  // async function updateSkillLevel(level: number) {
  //   const userToken = await sessionStorage.getItem('token') || await localStorage.getItem('ethosxAnalista:token')
  //   try {
  //     const objectParams = {
  //       token: userToken,
  //       data: {
  //         code: code,
  //         level
  //       }
  //     }
  //     const oldLevel = nivel
  //     setNivel(level)

  //     const response = await SkillsService.updateSkillLevel(objectParams)

  //     if (response.status === 'ok') {
  //       toast.success(response.msg)
  //     } else {
  //       toast.error(response.msg)
  //       setNivel(oldLevel)
  //     }


  //   } catch (error: any) {
  //     if (error.response) {
  //       toast.error(error.response.data.errorMessage)
  //     }

  //     console.log(error)
  //   }
  // }

  useEffect(() => {
    const colorsArr = getGradient(color, nivel)
    if (colorsArr.length === 5) {
      setColors(colorsArr)
    } else {
      for (let i = 1; colorsArr.length < 5; i++) {
        colorsArr.push('#CCCCCC')
      }
      setColors(colorsArr)
    }
  }, [nivel])

  return (
    <Rating 
      icon='star' 
      size="huge"
      defaultRating={nivel} 
      maxRating={5} 
      onRate={(event, data) => { 
        updateSkillLevel(Number(data.rating), code)
        setNivel(Number(data.rating))
      }}
    />
    // <SkillNiveisContainer>
    //   {
    //     colors.map((color, index) => (
    //       <SkillNivelCircle key={index} style={{ backgroundColor: color }} onClick={() => {
    //         updateSkillLevel(index + 1, code)
    //         setNivel(index + 1)
    //       }}></SkillNivelCircle>
    //     ))
    //   }
    // </SkillNiveisContainer>
  );
}

export default SkillNiveis;